/** @param {string} value */
export const validateMobile = (value) => {
  const digits = String(value || "").replace(/\D/g, "");
  if (!digits) return { valid: false, message: "Phone number is required" };
  if (digits.length !== 10) return { valid: false, message: "Enter a valid 10-digit mobile number" };
  return { valid: true, normalized: digits };
};

/** @param {string} value @param {{ required?: boolean }} options */
export const validateName = (value, options = { required: true }) => {
  const trimmed = String(value || "").trim().replace(/\s+/g, " ");
  if (!trimmed) {
    return options.required
      ? { valid: false, message: "This field is required" }
      : { valid: true, normalized: "" };
  }
  if (!/^[a-zA-Z]+(?: [a-zA-Z]+)*$/.test(trimmed)) {
    return { valid: false, message: "Use letters only (spaces allowed between names)" };
  }
  return { valid: true, normalized: trimmed };
};

/** @param {string} value */
export const validateEmailOptional = (value) => {
  const email = String(value || "").trim();
  if (!email) return { valid: true, normalized: "" };
  return validateEmail(email);
};

/** @param {string} value */
export const validateEmail = (value) => {
  const email = String(value || "").trim();
  if (!email) return { valid: false, message: "Email is required" };
  if (/\s/.test(email)) return { valid: false, message: "Email cannot contain spaces" };
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
  if (!email.includes("@")) return { valid: false, message: "Email must contain @" };
  if (!emailRegex.test(email)) {
    return { valid: false, message: "Enter a valid email address" };
  }
  const domain = email.split("@")[1] || "";
  const tld = domain.split(".").pop() || "";
  const allowedTlds = ["com", "in", "org", "edu", "net", "co", "io"];
  if (!allowedTlds.includes(tld.toLowerCase()) && domain.split(".").length < 2) {
    return { valid: false, message: "Enter a valid email domain" };
  }
  return { valid: true, normalized: email };
};
